import { render, staticRenderFns } from "./NecessaryProductsPanel.vue?vue&type=template&id=53a734a3&"
import script from "./NecessaryProductsPanel.vue?vue&type=script&lang=ts&"
export * from "./NecessaryProductsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports